<template>
    <div>
        <div class="listingPageTitle">
            <h1>Log Activity Type Maintenance</h1>
            <ItemModal ref="modal" :itemName="'Log Activity Type'"
                            :formRows="newFormRows"
                            :saveItemFunction="save"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Description: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'code'}" />
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'LogActivityListing',
    components: {ItemModal, ListingTable},
    data: function() {
        return {
            logActivityTypes: [],
            searchText: "",
            onlyShowActive: true,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Code",
                    width: "10%",
                    fieldName: "code",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Description",
                    width: "60%",
                    fieldName: "description"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive",
                    showEditFieldName: "isActive",
                    showListingFieldName: null
                }
            ],
            newFormRows: [
                {
                    name: 'Code',
                    propertyName: 'code',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Description',
                    propertyName: 'description',
                    required: true,
                    element: 'textarea'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                onEdit: this.edit
            },
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "description",
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });

            }
            return criteria;
        }
    },
    mounted() {
        this.loadRecords();
    },
    methods: {
        loadRecords: async function() {
            return await data.getLogActivityTypes(this.searchText, false);
        },
        save: async function(saveObject) {
            return await this.save_common(saveObject, true); 
        },
        save_common: async function(saveObject, displaySuccess) {
            var retObject = this.processSaveResult(await data.saveLogActivityType(saveObject));

            if(retObject.success) {
                if(displaySuccess)
                    this.componentKey++;

                if(retObject.id)
                    saveObject.id = retObject.id;

                return retObject;
                
            }
            else
                return retObject;
        },
        edit: async function(values) {
            var editRecord = await data.getLogActivityType(values.id);  
            this.$refs.modal.editRecord(editRecord.id, editRecord);  
        },
        deleteRecord: async function(values) {
            if(confirm('Are you sure you want to delete this log activity type?')) {
                var status = this.processDeactivateResult(await data.deleteLogActivityType(values.id));
                if(status.success) 
                    values.isActive = false;                     
            }
        },
        reactivateRecord: async function(values) {
            values.isActive = true;
            var status = await this.save_common(values, false);
            if(!status.success)
                values.isActive = false;
        },
    }
}
</script>

